import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OpenReadmeService } from '@services/readme/open-readme.service';

@Component({
    selector: 'dashboard-message-item',
    templateUrl: './dashboard-message-item.component.html',
    styleUrls: ['./dashboard-message-item.component.scss'],
    standalone: false
})
export class DashboardMessageItemComponent {

  @Input() item: any;
  @Input() showAll: boolean;
  @Output() onStatusChange = new EventEmitter<any>();

  constructor(private router: Router, private readme: OpenReadmeService) {
  }

  routeTo(route, params) {
    this.router.navigate(route, { queryParams: params });
  }

  readMe(name, tag) {
    this.readme.openReadMe({ name: name, tag: tag });
  }

  statusChange() {
    this.onStatusChange.emit({ target: this.item._id, value: this.item.readStatus });
  }

  fixSpaces(str: string): string {
    return str.replace(/&nbsp;/g, ' ');
  }
}
